import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["height", "name", "refHandlers", "targetWidget"];
import { getFullUrl } from 'hubspot-url-utils';
import styled from 'styled-components';
import { subDomain } from '../utils/url';
import PortalIdParser from 'PortalIdParser';
import getAppName from '../utils/getAppName';
import { jsx as _jsx } from "react/jsx-runtime";
const FrameStyled = styled.iframe.withConfig({
  displayName: "Frame__FrameStyled",
  componentId: "sc-1h7y9ia-0"
})(["border:0;width:100%;height:", ";"], ({
  $height
}) => `${$height}px` || 'auto');
const isLocal = /^local/.test(document.location.hostname);
const EmbeddedUIBaseURL = `${getFullUrl(isLocal ? 'local' : subDomain)}/embedded-academy-ui`;
export const Frame = _ref => {
  let {
      height,
      name,
      refHandlers = [],
      targetWidget
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const portalIdFromUrl = PortalIdParser.getPortalIdFromPath();
  if (!portalIdFromUrl && targetWidget !== 'staticPublic') {
    return /*#__PURE__*/_jsx("p", {
      children: "Portal ID required"
    });
  }
  const parentAppName = getAppName();
  if (!parentAppName) {
    return /*#__PURE__*/_jsx("p", {
      children: "Not hosted in HubSpot app"
    });
  }
  const params = new URLSearchParams({
    parentAppName
  });
  const targetUrl = targetWidget === 'staticPublic' ? `${EmbeddedUIBaseURL}/static?${params.toString()}` : `${EmbeddedUIBaseURL}/${portalIdFromUrl}/${targetWidget}?${params.toString()}`;
  return /*#__PURE__*/_jsx(FrameStyled, Object.assign({}, rest, {
    $height: height,
    "data-test-id": "embedded-academy-frame",
    name: name,
    ref: r => {
      for (const handler of refHandlers) {
        handler(r);
      }
    },
    src: targetUrl
  }));
};